import classes from "./Spinner.module.css";

const Spinner = () => {
    return (
        <div className={classes.Spinner}>Loading...</div>
    )
}

export default Spinner;